import React from 'react'
import * as S from './styles'

export function TabPanel({ theme, children, stepState, index }) {
	const active = stepState.index === index

	return (<S.Container
	role="tabpanel"
	hidden={!active}
	id={`simple-tabpanel-${index}`}
	aria-labelledby={`simple-tab-${index}`}
	maxWidth={theme.config.containerWidth}
	active={active}>
		{active && children}
	</S.Container>)
}
